export class Userdocument {
  public id:number;
  public name:string;
  public firstName:string;
  public lastName:string;
  public birthDate:string;
  public type:string;
  public isValidated = false;
  public pathrecto:string;
  public pathverso:string;
  public pathrectoverso:string;
  public isPdf = false;
  public isRectoVerso = false;
  public user_id:string;

  constructor() {

  }

}
